import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatFilterText',
})
export class FormatFilterTextPipe implements PipeTransform {
  transform(text: string | null | undefined): string {
    if(!text){
      return 'Todos';
    }

    return text;
  }
}
